// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1_19e","log":"ModalInventoryLogs_log__2JOX_","date":"ModalInventoryLogs_date__3188m","userName":"ModalInventoryLogs_userName__2-3yG"};